import React, { useState } from "react";
import { Loader2, X, ChevronLeft, ChevronRight } from "lucide-react";
import { useScenarioGenerationTracker } from "../../contexts/ScenarioGenerationTrackerContext";

export default function GenerationTrackerDock() {
  const { activeRuns, dismiss } = useScenarioGenerationTracker();
  const [idx, setIdx] = useState(0);

  if (!activeRuns.length) return null;

  const safeIdx = Math.min(idx, activeRuns.length - 1);
  const run = activeRuns[safeIdx];

  return (
    <div className="fixed bottom-6 right-6 z-40 w-80 bg-card rounded-xl shadow-lg border border-border p-4">
      <div className="flex items-start gap-3">
        <Loader2 className="h-4 w-4 text-primary animate-spin mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <span className="text-sm font-semibold text-foreground">
              Generating scenarios
              {activeRuns.length > 1 && (
                <span className="ml-2 text-xs text-muted-foreground">
                  {safeIdx + 1} / {activeRuns.length}
                </span>
              )}
            </span>
            <button
              type="button"
              onClick={() => dismiss(run.id)}
              className="text-muted-foreground hover:text-muted-foreground"
              title="Dismiss — generation continues in the background"
            >
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
          <p className="text-xs text-muted-foreground mt-1">
            They'll be added to your scenarios list automatically.
          </p>
          <div className="w-full bg-muted rounded-full h-1.5 overflow-hidden mt-3">
            <div
              className="bg-primary h-full transition-all duration-500"
              style={{ width: `${run.progress_percent || 0}%` }}
            />
          </div>
          <p className="text-xs text-muted-foreground mt-2">
            {run.completed_count || 0} of {run.requested_count} ready
          </p>

          {activeRuns.length > 1 && (
            <div className="flex items-center justify-between mt-3 pt-2 border-t border-border">
              <button
                type="button"
                onClick={() => setIdx((i) => Math.max(0, i - 1))}
                disabled={safeIdx === 0}
                className="text-muted-foreground hover:text-muted-foreground disabled:opacity-30"
              >
                <ChevronLeft className="h-4 w-4" />
              </button>
              <div className="flex gap-1">
                {activeRuns.map((r, i) => (
                  <span
                    key={r.id}
                    className={`h-1.5 w-1.5 rounded-full ${i === safeIdx ? "bg-primary" : "bg-gray-300"}`}
                  />
                ))}
              </div>
              <button
                type="button"
                onClick={() => setIdx((i) => Math.min(activeRuns.length - 1, i + 1))}
                disabled={safeIdx === activeRuns.length - 1}
                className="text-muted-foreground hover:text-muted-foreground disabled:opacity-30"
              >
                <ChevronRight className="h-4 w-4" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
